// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__HZyZi","error":"Textarea_error__1D0P5","readonly":"Textarea_readonly__2Yabk","disabled":"Textarea_disabled__8GASK"};